import { Navigate, useRoutes, RouteObject } from 'react-router-dom';
import { LogoOnlyLayout, Logo } from '@onedesign/ui';
import DashboardLayout from 'layouts/dashboard';
import AuthLayout from 'layouts/auth';
import Login from 'pages/Login';
import Register from 'pages/Register';
import VerifyEmail from 'pages/VerifyEmail';
import ResetPassword from 'pages/ResetPassword';
import ResetPasswordRequest from 'pages/ResetPasswordRequest';
import { lazyLoad } from './LazyLoad';
import { UNIVERSAL_ROUTE, PATH } from './routeConfig';
import { scheduleRoutes } from './schedule';
import { profileRoutes } from './profile';
import { courseRoutes } from './course';
import { notificationRoutes } from './notification';
import { teacherApplicationRoutes } from './teacherApplication';
import { crossSubjectApplicationRoutes } from './crossSubjectApplication';
import { oneAnswerRoutes } from './oneAnswer';
import { teacherTerminatedContractRoutes } from './teacherTerminatedContract';
import { requestSignEmploymentContractRoutes } from './requestSignEmploymentContract';

export const Routes = () => {
  const routes: RouteObject[] = [
    {
      path: UNIVERSAL_ROUTE.ROOT,
      element: <DashboardLayout />,
      children: [
        ...scheduleRoutes,
        ...profileRoutes,
        ...courseRoutes,
        ...notificationRoutes,
        ...teacherApplicationRoutes,
        ...crossSubjectApplicationRoutes,
        ...oneAnswerRoutes,
        ...teacherTerminatedContractRoutes,
        ...requestSignEmploymentContractRoutes,
      ],
    },
    {
      element: <AuthLayout />,
      children: [
        {
          path: UNIVERSAL_ROUTE.LOGIN,
          element: <Login />,
        },
        {
          path: UNIVERSAL_ROUTE.REGISTER,
          element: <Register />,
        },
        {
          path: UNIVERSAL_ROUTE.VERIFY_EMAIL,
          element: <VerifyEmail />,
        },
        {
          path: UNIVERSAL_ROUTE.RESET_PASSWORD,
          element: <ResetPassword />,
        },
        {
          path: UNIVERSAL_ROUTE.RESET_PASSWORD_REQUEST,
          element: <ResetPasswordRequest />,
        },
      ],
    },
    {
      path: UNIVERSAL_ROUTE.OTHER,
      element: <LogoOnlyLayout logo={<Logo />} />,
      children: [
        {
          path: UNIVERSAL_ROUTE.OTHER,
          element: <Navigate to={PATH.NOT_FOUND} replace />,
        },
        {
          path: UNIVERSAL_ROUTE.NOT_FOUND,
          element: lazyLoad(() => import('pages/NotFound')),
        },
      ],
    },
  ];

  return useRoutes(routes);
};
